import React from 'react';
import { getUeContextUpdate } from '../utils';
import { UniversalEditorContext } from './universal-editor-context';
export const UeContainerProvider = ({ value, children, }) => {
    const { container, propertyPath } = value;
    const ueContext = React.useContext(UniversalEditorContext);
    const ueContextUpdate = React.useMemo(() => getUeContextUpdate(ueContext, propertyPath, container.fields), [ueContext, propertyPath, container]);
    return (React.createElement(UniversalEditorContext.Provider, { value: ueContextUpdate }, children));
};
//# sourceMappingURL=container-context.js.map